var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(!_vm.isUserAuthenticated || _vm.loading)?_c('Loader'):[_c('Header'),_c('main',{attrs:{"role":"main"}},[_c('router-view')],1),_c('Notifications'),_c('ConnectionMethodBadge')]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }